import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import styles from './BottomNav.style';
import Anchor from '../../../atoms/Anchor';
import List from '../../List';
import ListItem from '../../List/ListItem';
import SubmenuNav from '../SubmenuNav';
import analyticsConstants from '../../../../constants/analyticsConstants';
import ArrowUp from '../../../../static/images/icons/ArrowUp';
import { navLabels } from '../../../../constants/labels/en/label';
import { getElementHeight, getDocumentHeight } from '../../../../utils/utilityFunction';
import Location from '../../../../static/images/icons/Location';
import Search from '../../../../static/images/icons/Search';
var BottomNav = /*#__PURE__*/function (_Component) {
  _inherits(BottomNav, _Component);
  var _super = _createSuper(BottomNav);
  function BottomNav() {
    _classCallCheck(this, BottomNav);
    return _super.apply(this, arguments);
  }
  _createClass(BottomNav, [{
    key: "render",
    value:
    // Set default props

    function render() {
      var _this = this,
        _headerAnalytics$anal,
        _headerAnalytics$anal2,
        _headerAnalytics$anal3,
        _headerAnalytics$anal4;
      var headerAnalytics = analyticsConstants.globalHeader;
      var appointmentCta = this.props.appointmentCta;
      var pharmacyCta = this.props.pharmacyCta;
      var multiLocationCta = this.props.multiLocationCta;
      var isEmergencyBtn = this.props.isEmergencyBtn;
      var headerMultiLocation = this.props.showMultiLocationBtn;
      return __jsx("div", {
        className: this.props.className
      }, __jsx(List, {
        id: "mainNavigation",
        className: "navbar-nav key-category"
      }, this.props.keyCategories.map(function (keyCategory) {
        return __jsx(NavItems, {
          burgerToggle: _this.props.burgerToggle,
          key: keyCategory.sys.id,
          keyCategory: keyCategory,
          variation: _this.props.variation,
          dataAnalyticsValue: keyCategory && keyCategory.dataAnalyticsValue
        });
      })), __jsx("div", {
        className: "menuButtonWrapper"
      }, multiLocationCta ? __jsx("div", null, __jsx(Anchor, {
        title: multiLocationCta.label || 'Find Location',
        "aria-label": multiLocationCta.ariaLabel,
        to: multiLocationCta.url,
        hyperlinkType: multiLocationCta.hyperlinkType,
        styleType: "primary-anchor",
        className: " nav-btn",
        ctaBehavior: multiLocationCta.behavior,
        "data-analytics-type": headerAnalytics.analyticsType.GLOBAL_NAV,
        "data-analytics-value": multiLocationCta && multiLocationCta.dataAnalyticsValue ? multiLocationCta.dataAnalyticsValue.toLowerCase() : headerAnalytics.analyticsValue.GLOBAL_NAV_APPOINTMENT,
        "data-analytics-variation": this.props.variation
      }, __jsx(Location, {
        className: "svg-search-icon"
      }), multiLocationCta.label || 'Find Location')) : headerMultiLocation && __jsx("div", null, __jsx(Anchor, {
        title: this.props.viewMoreLabel ? this.props.viewMoreLabel : 'Find Location',
        onClick: this.props.handleClick,
        styleType: "primary-anchor",
        className: " icon-button nav-btn ",
        tabIndex: 0
      }, __jsx(Search, {
        className: "svg-search-icon"
      }), this.props.viewMoreLabel ? this.props.viewMoreLabel : 'Find Location')), isEmergencyBtn ? __jsx("div", null, __jsx(Anchor, {
        title: (pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.label) || 'Emergency',
        "aria-label": pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.ariaLabel,
        icon: true,
        to: pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.url,
        hyperlinkType: pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.hyperlinkType,
        styleType: "primary-anchor",
        className: "emergencyBtn nav-btn",
        ctaBehavior: pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.behavior,
        "data-analytics-type": headerAnalytics === null || headerAnalytics === void 0 ? void 0 : (_headerAnalytics$anal = headerAnalytics.analyticsType) === null || _headerAnalytics$anal === void 0 ? void 0 : _headerAnalytics$anal.GLOBAL_NAV,
        "data-analytics-value": pharmacyCta !== null && pharmacyCta !== void 0 && pharmacyCta.dataAnalyticsValue ? pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.dataAnalyticsValue.toLowerCase() : headerAnalytics === null || headerAnalytics === void 0 ? void 0 : (_headerAnalytics$anal2 = headerAnalytics.analyticsValue) === null || _headerAnalytics$anal2 === void 0 ? void 0 : _headerAnalytics$anal2.GLOBAL_NAV_APPOINTMENT,
        "data-analytics-variation": this.props.variation
      }, __jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
      }, __jsx("g", {
        transform: "translate(-50.938 -147.563)"
      }, __jsx("path", {
        d: "M70.382,165.063v6.945H63.438v10.111h6.945v6.944H80.493v-6.944h6.945V172.008H80.493v-6.945Z",
        transform: "translate(-12 -17)"
      }))), (pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.label) || 'Emergency')) : pharmacyCta && __jsx("div", null, __jsx(Anchor, {
        title: (pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.label) || 'Order Food & Medicine',
        "aria-label": pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.ariaLabel,
        to: pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.url,
        hyperlinkType: pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.hyperlinkType,
        styleType: "primary-anchor",
        className: " nav-btn",
        ctaBehavior: pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.behavior,
        "data-analytics-type": headerAnalytics === null || headerAnalytics === void 0 ? void 0 : (_headerAnalytics$anal3 = headerAnalytics.analyticsType) === null || _headerAnalytics$anal3 === void 0 ? void 0 : _headerAnalytics$anal3.GLOBAL_NAV,
        "data-analytics-value": pharmacyCta !== null && pharmacyCta !== void 0 && pharmacyCta.dataAnalyticsValue ? pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.dataAnalyticsValue.toLowerCase() : headerAnalytics === null || headerAnalytics === void 0 ? void 0 : (_headerAnalytics$anal4 = headerAnalytics.analyticsValue) === null || _headerAnalytics$anal4 === void 0 ? void 0 : _headerAnalytics$anal4.GLOBAL_NAV_APPOINTMENT,
        "data-analytics-variation": this.props.variation
      }, (pharmacyCta === null || pharmacyCta === void 0 ? void 0 : pharmacyCta.label) || 'Order Food & Medicine')), appointmentCta && __jsx("div", null, __jsx(Anchor, {
        title: appointmentCta.label,
        "aria-label": appointmentCta.ariaLabel,
        to: appointmentCta.url,
        hyperlinkType: appointmentCta.hyperlinkType,
        styleType: "primary-anchor",
        className: " nav-btn",
        ctaBehavior: appointmentCta.behavior,
        "data-analytics-type": headerAnalytics.analyticsType.GLOBAL_NAV,
        "data-analytics-value": appointmentCta && appointmentCta.dataAnalyticsValue ? appointmentCta.dataAnalyticsValue.toLowerCase() : headerAnalytics.analyticsValue.GLOBAL_NAV_APPOINTMENT,
        "data-analytics-variation": this.props.variation
      }, appointmentCta.label))));
    }
  }]);
  return BottomNav;
}(Component);
_defineProperty(BottomNav, "defaultProps", {
  className: ''
});
var NavItems = /*#__PURE__*/function (_Component2) {
  _inherits(NavItems, _Component2);
  var _super2 = _createSuper(NavItems);
  function NavItems(props) {
    var _this2;
    _classCallCheck(this, NavItems);
    _this2 = _super2.call(this, props);
    _this2.toggleChildMenu = _this2.toggleChildMenu.bind(_assertThisInitialized(_this2));
    _this2.handleOutsideClick = _this2.handleOutsideClick.bind(_assertThisInitialized(_this2));
    _this2.state = {
      isMenuOpen: false
    };
    return _this2;
  }
  _createClass(NavItems, [{
    key: "toggleChildMenu",
    value: function toggleChildMenu(event) {
      event && event.preventDefault();
      if (!this.state.isMenuOpen) {
        // attach/remove event handler
        document.addEventListener('click', this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', this.handleOutsideClick, false);
      }
      this.setState(function (state) {
        return {
          isMenuOpen: !state.isMenuOpen
        };
      });
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      if (!this.node.contains(e.target)) this.toggleChildMenu();
    }

    /**
     * componentDidUpdate
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var documentHeight = getDocumentHeight();
      var navHeight = getElementHeight('nav');
      var navOverlayHeight = documentHeight - navHeight;
      var navOverlayElement = document.getElementsByClassName('nav-overlay-show')[0];
      if (navOverlayElement) navOverlayElement.style.height = "".concat(navOverlayHeight, "px");
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var headerAnalytics = analyticsConstants.globalHeader;
      var _this$props$keyCatego = this.props.keyCategory,
        sys = _this$props$keyCatego.sys,
        url = _this$props$keyCatego.url,
        hyperlinkType = _this$props$keyCatego.hyperlinkType,
        label = _this$props$keyCatego.label,
        behavior = _this$props$keyCatego.behavior,
        keyCategoryName = _this$props$keyCatego.keyCategoryName,
        groupCollection = _this$props$keyCatego.groupCollection;
      var id = sys && sys.id;
      var group = groupCollection && groupCollection.items;
      var navOverlayClassModifier = this.state.isMenuOpen ? 'nav-overlay-show' : 'nav-overlay-hide';
      var navOverlayClass = ['nav-overlay', navOverlayClassModifier];
      return __jsx(Fragment, null, __jsx(ListItem, {
        className: "nav-item key-category-item",
        key: id
      }, !group && __jsx("div", {
        className: "heading_four"
      }, __jsx(Anchor, {
        title: label,
        to: url,
        hyperlinkType: hyperlinkType,
        handleLinkClick: this.props.burgerToggle,
        className: "key-category-link",
        ctaBehavior: behavior,
        "data-analytics-type": headerAnalytics.analyticsType.GLOBAL_NAV,
        "data-analytics-value": headerAnalytics.analyticsValue.GLOBAL_NAV_CATEGORY_LINK,
        "data-analytics-variation": this.props.variation,
        "aria-label": label === 'Speciality + ER' ? navLabels.SPECIALTY : null
      }, label)), group && __jsx(Fragment, null, __jsx("div", {
        className: "heading_four",
        ref: function ref(node) {
          _this3.node = node;
        }
      }, __jsx(Anchor, {
        title: keyCategoryName,
        to: "#",
        noLink: true,
        handleLinkClick: this.toggleChildMenu,
        className: "key-category-menu ".concat(this.state.isMenuOpen ? 'open' : ''),
        "aria-expanded": this.state.isMenuOpen ? 'true' : 'false',
        "data-analytics-type": headerAnalytics.analyticsType.GLOBAL_NAV,
        "data-analytics-value": headerAnalytics.analyticsValue.GLOBAL_NAV_CATEGORY_MENU,
        "data-analytics-variation": this.props.variation
      }, keyCategoryName, __jsx(ArrowUp, {
        className: "".concat(this.state.isMenuOpen ? 'arrow-up' : 'arrow-down')
      }))), __jsx(SubmenuNav, {
        className: "sub-menu",
        isMenuOpen: this.state.isMenuOpen,
        menuGroup: group
      }))));
    }
  }]);
  return NavItems;
}(Component);
export default styled(BottomNav).withConfig({
  componentId: "sc-1m6uy3j-0"
})(["", ";"], styles);
//export default Carousel;
export { BottomNav as BottomNavVanilla };
export { NavItems as NavItemsVanilla };